export function openExternalLink(url) {
  if (!url || !window) {
    return;
  }
  window.open(url, '_system', 'location=no');
}

export function openExternalLinkInPane(url) {
  if (!url || !window) {
    return;
  }
  window.location.href = url;
}

export function getUrlParams(url) {
  url = new URL(url);
  const searchParams = new URLSearchParams(url.search);
  const params = {};
  for (const [key, value] of searchParams.entries()) {
    params[key] = value;
  }
  return params;
}

export function getPathName(url) {
  return new URL(url).pathname;
}
